const urls: any = {
  '8080': 'http://localhost:8080',
  '8000': 'http://localhost:8000',
  '3000': 'http://localhost:3000',
  '5000': 'http://localhost:5000',
};

export function getApiBaseUrl() {
  const port = process.env.REACT_APP_MDM_BASE_API_PORT;
  if (port) {
    const url = urls[port];
    if (url) {
      return url;
    }
  }
  return window.location.protocol + '//' + window.location.host;
}

export function getApiBase2Url() {
  const port = process.env.REACT_APP_MDM_BASE2_API_PORT;
  if (port) {
    const url = urls[port];
    if (url) {
      return url;
    }
  }
  return window.location.protocol + '//' + window.location.host;
}
